module.exports = __webpack_public_path__ + "static/img/brees-2001-slide-3.27a1c8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2001-slide-3.jpg
// module id = b3Z3
// module chunks = 1